import axios from 'axios';

// Mismo patrón de detección de entorno que virtualPosService: REACT_APP_BACKEND_URL
// si está definida; rutas relativas fuera de localhost; backend local en dev.
const getApiBaseUrl = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl) {
    return backendUrl.replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return '';
  }
  return 'http://localhost:3010';
};

const API_BASE_URL = getApiBaseUrl();

// Nunca lanza: siempre { status, data }. status 0 = no hubo respuesta HTTP.
export async function simularCalculo(body) {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/calculator/calculate`, body, {
      timeout: 35000,
      validateStatus: () => true,
    });
    return { status: res.status, data: res.data ?? {} };
  } catch (error) {
    return { status: 0, data: { error: error.message } };
  }
}

export function resumenError(status, data) {
  if (status === 404 && data?.error === 'SIN_TARIFA') {
    return `Plan sin tarifa para esa combinación: revisa el tab Precios Base (UF). ${data?.message ?? ''}`.trim();
  }
  if (status === 400) {
    if (data?.message) return data.message;
    if (data?.details) return `Datos inválidos: ${JSON.stringify(data.details)}`;
    return 'Datos inválidos para el cálculo';
  }
  if (status === 401) {
    return 'No autorizado: revisa CALCULATOR_SERVICE_SECRET en el backend de tadmin.';
  }
  if (status === 500 && data?.error === 'CONFIG_ERROR') {
    return 'El microservicio calculator no tiene SERVICE_SECRET configurado.';
  }
  if (status === 0) {
    return `No se pudo contactar el backend de tadmin (${data?.error ?? 'sin respuesta'}).`;
  }
  return data?.error || data?.message || `Error ${status} al calcular`;
}
